export default __webpack_public_path__ + "static/media/flag-cuba.7e02a730.svg";